import { ContextData } from "data/Context";
import { useContext, useState, useEffect } from "react";
import { Button, Seal, Ingredient, NoticePopUP, Loader } from "components";
import { Link, useHistory } from "react-router-dom";
import { ConfiguratorSlide, NamerPopup } from "components";
import { useWindowDimensions } from "hooks";
import GGCStoreFront, { ShopifyCart } from "services/ggc-storefront-api";

export default function Cart() {
  const contextReact: any = useContext(ContextData);
  const [popupNotice, setPopupNotice] = useState(false);
  const { height, width }: any = useWindowDimensions();
  const [togo, setTogo] = useState(null);
  let history = useHistory();
  const cardReader = GGCStoreFront.getReaderSerialNumber();
  console.log(contextReact.cart);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cart-page">
      {contextReact.cart.map((element: any, i: number) => {
        console.log(element);
        return (
          <div className="cart-con" key={i + "key " + element.name}>
            <CartItem
              name={element.name}
              shell={element.shell}
              sweets={element.sweets}
              addIns={element.addIns}
              addOns={element.addOns}
              count={element.count}
              index={i}
            />
          </div>
        );
      })}

      {contextReact.cart.length === 0 ? (
        <EmptyState />
      ) : (
        <>
          <div className="cart-allergyNote">
            <span>Allergen Note: </span>
            All of our chocolates are made by hand using shared equipment, which
            processes milk, wheat, soy, peanuts, tree nuts, and eggs. Please
            know that while we do our best to prevent cross-contamination, we
            are not an allergy-free facility.
          </div>
        </>
      )}
      {contextReact.cart.length === 0 ? (
        ""
      ) : (
        <>
          <CostSummary title="Cost Summary" />
          {/* <br /> */}

          <div className="cart-con --shippingOption">
            <div className="cart-itemHeader --summary">
              <div className="cart-name  --summary">Location</div>
            </div>
            <br />

            <div className="cart-shippingOption">
              <div
                className="cart-shippingOptionCon"
                onClick={() => {
                  setTogo(false);
                  GGCStoreFront.getInstance().setDineIn(true, () => {});
                }}
              >
                <div
                  className="cart-shippingOptionItem"
                  style={{
                    filter: togo ? " grayscale(100%)  " : "",
                    opacity: togo ? " .6" : "",
                  }}
                >
                  <img
                    src="\images\dinein.png"
                    alt="dine in"
                    className="cart-shippingOptionItemImg"
                  />
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="configurator-ingredientRing --2nd"
                  >
                    <path
                      d="M79.2789 42.9225L77.817 40.9795C77.5679 40.6516 77.4331 40.2522 77.4331 39.8416C77.4331 39.4309 77.5679 39.0315 77.817 38.7037L79.2521 36.7606C79.817 36.0027 80.0566 35.0536 79.9184 34.1209C79.7802 33.1882 79.2754 32.3477 78.5145 31.7832L76.5696 30.3459C76.2364 30.0989 75.9924 29.7518 75.874 29.3561C75.7556 28.9605 75.7691 28.5374 75.9125 28.15L76.744 25.8876C77.0658 25.003 77.024 24.0283 76.6274 23.1741C76.2309 22.3199 75.5116 21.6549 74.625 21.3227L72.3448 20.4843C71.9549 20.3419 71.6217 20.0785 71.3946 19.7333C71.1674 19.3881 71.0586 18.9794 71.0841 18.5678L71.2451 16.159C71.304 15.2191 70.986 14.2943 70.3603 13.5862C69.7347 12.8781 68.8522 12.4443 67.9055 12.3794L65.4778 12.2064C65.0656 12.1793 64.6733 12.0209 64.3591 11.7547C64.0449 11.4885 63.8259 11.1288 63.7343 10.7291L63.1978 8.3735C62.9806 7.46078 62.4098 6.66971 61.6091 6.17154C60.8083 5.67337 59.842 5.5082 58.9194 5.71179L56.5455 6.23082C56.1388 6.31747 55.7147 6.27245 55.3357 6.10238C54.9567 5.93231 54.6427 5.64615 54.4397 5.28591L53.2594 3.18316C52.7872 2.37072 52.0116 1.77553 51.1004 1.52644C50.1892 1.27736 49.2157 1.39442 48.3908 1.8523L46.4059 2.9303C46.0428 3.13132 45.6234 3.20891 45.2117 3.15124C44.8 3.09356 44.4187 2.90379 44.1259 2.61089L42.5163 1.02718C41.8394 0.36879 40.9294 0 39.9816 0C39.0337 0 38.1236 0.36879 37.4467 1.02718L35.7299 2.73067C35.4363 3.0219 35.0561 3.21153 34.6454 3.27145C34.2347 3.33138 33.8153 3.25843 33.4497 3.06339L31.3038 1.90554C30.4689 1.45939 29.4902 1.35872 28.5808 1.62544C27.6714 1.89217 26.905 2.50468 26.4487 3.32955L25.2818 5.44562C25.0795 5.80332 24.7677 6.08776 24.3915 6.25766C24.0153 6.42757 23.5943 6.47411 23.1896 6.39052L20.8156 5.8981C19.895 5.69843 18.9321 5.8655 18.1344 6.36333C17.3367 6.86117 16.7679 7.64994 16.5505 8.55981L16.0274 10.9154C15.9396 11.317 15.7242 11.68 15.4127 11.9508C15.1011 12.2216 14.7101 12.3858 14.2974 12.4193L11.8697 12.6056C10.9228 12.6771 10.0429 13.1176 9.42223 13.8308C8.80152 14.5439 8.49044 15.4719 8.55696 16.4119L8.73133 18.8074C8.76081 19.2195 8.65534 19.63 8.43057 19.9777C8.2058 20.3255 7.87368 20.5919 7.48393 20.7371L5.21736 21.5889C4.33015 21.9233 3.61226 22.5924 3.22028 23.45C2.82831 24.3077 2.794 25.2844 3.125 26.167L3.96997 28.4295C4.10506 28.8059 4.11824 29.2148 4.00762 29.5989C3.897 29.9831 3.66817 30.3234 3.35306 30.5722L1.4218 32.0228C1.04664 32.3042 0.730926 32.6561 0.492841 33.0585C0.254756 33.461 0.0988546 33.906 0.0340922 34.3682C-0.0306702 34.8304 -0.00295748 35.3007 0.115462 35.7523C0.233881 36.2039 0.440771 36.6279 0.724344 37.0002L2.17279 38.9299C2.41699 39.2623 2.54853 39.6631 2.54853 40.0745C2.54853 40.4858 2.41699 40.8866 2.17279 41.219L0.724344 43.1621C0.160153 43.9179 -0.0791344 44.8648 0.0591417 45.7954C0.197418 46.7259 0.701877 47.5641 1.46191 48.1261L3.40676 49.5768C3.74 49.8238 3.98384 50.1709 4.10225 50.5666C4.22066 50.9622 4.20731 51.3852 4.06394 51.7727L3.2324 54.0351C2.91129 54.9214 2.95504 55.8975 3.35421 56.752C3.75338 57.6064 4.47577 58.2704 5.36488 58.6L7.64487 59.4384C8.0323 59.583 8.36268 59.8473 8.58725 60.1924C8.81182 60.5374 8.91877 60.9449 8.89226 61.3548L8.7179 63.8435C8.65887 64.7812 8.97511 65.7042 9.59791 66.4119C10.2207 67.1196 11.0997 67.5549 12.0441 67.6232L14.4717 67.7829C14.8868 67.8121 15.2814 67.9727 15.5977 68.241C15.9139 68.5093 16.135 68.8711 16.2286 69.2734L16.7652 71.629C16.9824 72.5417 17.5532 73.3328 18.3539 73.831C19.1547 74.3292 20.1209 74.4943 21.0435 74.2907L23.4175 73.7717C23.8223 73.686 24.2442 73.7315 24.6209 73.9016C24.9976 74.0718 25.3092 74.3574 25.5099 74.7166L26.7036 76.8194C27.1732 77.6309 27.9465 78.2258 28.8555 78.475C29.7646 78.7242 30.7359 78.6075 31.5587 78.1502L33.5437 77.0722C33.9094 76.8723 34.3305 76.7954 34.7439 76.853C35.1574 76.9106 35.541 77.0995 35.8371 77.3916L37.4332 78.962C38.1068 79.6268 39.0182 80 39.9681 80C40.9181 80 41.8294 79.6268 42.5029 78.962L44.2331 77.2719C44.5245 76.9817 44.9025 76.7927 45.3109 76.7327C45.7192 76.6728 46.1362 76.7452 46.4998 76.9391L48.6457 78.0837C49.479 78.5309 50.4566 78.6336 51.3658 78.3694C52.275 78.1052 53.0423 77.4955 53.5009 76.673L54.6677 74.5569C54.8675 74.1937 55.181 73.9049 55.561 73.7344C55.941 73.5639 56.3666 73.5209 56.7734 73.612L59.1473 74.1044C60.066 74.3002 61.0254 74.1312 61.8201 73.6337C62.6148 73.1362 63.1816 72.3498 63.399 71.4427L63.9221 69.0871C64.0126 68.6844 64.2306 68.3211 64.5444 68.0504C64.8582 67.7798 65.2511 67.616 65.6656 67.5832L68.0798 67.3969C69.0268 67.3254 69.9066 66.8849 70.5273 66.1718C71.148 65.4586 71.4591 64.5307 71.3926 63.5907L71.2182 61.1951C71.1909 60.7834 71.2973 60.3738 71.5218 60.0265C71.7463 59.6792 72.0771 59.4125 72.4656 59.2654L74.7322 58.4136C75.6194 58.0792 76.3373 57.4102 76.7293 56.5525C77.1212 55.6948 77.1556 54.7181 76.8246 53.8355L75.9796 51.573C75.837 51.1867 75.8225 50.7653 75.9383 50.3703C76.0541 49.9752 76.2941 49.6273 76.6233 49.3771L78.5546 47.9132C78.9337 47.6337 79.2534 47.2825 79.4952 46.8799C79.737 46.4773 79.8961 46.0313 79.9634 45.5674C80.0307 45.1035 80.0049 44.631 79.8875 44.1771C79.77 43.7232 79.5631 43.2968 79.2789 42.9225V42.9225Z"
                      fill="#E31B23"
                    />
                  </svg>
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="configurator-ingredientRing"
                  >
                    <path
                      d="M79.2789 42.9225L77.817 40.9795C77.5679 40.6516 77.4331 40.2522 77.4331 39.8416C77.4331 39.4309 77.5679 39.0315 77.817 38.7037L79.2521 36.7606C79.817 36.0027 80.0566 35.0536 79.9184 34.1209C79.7802 33.1882 79.2754 32.3477 78.5145 31.7832L76.5696 30.3459C76.2364 30.0989 75.9924 29.7518 75.874 29.3561C75.7556 28.9605 75.7691 28.5374 75.9125 28.15L76.744 25.8876C77.0658 25.003 77.024 24.0283 76.6274 23.1741C76.2309 22.3199 75.5116 21.6549 74.625 21.3227L72.3448 20.4843C71.9549 20.3419 71.6217 20.0785 71.3946 19.7333C71.1674 19.3881 71.0586 18.9794 71.0841 18.5678L71.2451 16.159C71.304 15.2191 70.986 14.2943 70.3603 13.5862C69.7347 12.8781 68.8522 12.4443 67.9055 12.3794L65.4778 12.2064C65.0656 12.1793 64.6733 12.0209 64.3591 11.7547C64.0449 11.4885 63.8259 11.1288 63.7343 10.7291L63.1978 8.3735C62.9806 7.46078 62.4098 6.66971 61.6091 6.17154C60.8083 5.67337 59.842 5.5082 58.9194 5.71179L56.5455 6.23082C56.1388 6.31747 55.7147 6.27245 55.3357 6.10238C54.9567 5.93231 54.6427 5.64615 54.4397 5.28591L53.2594 3.18316C52.7872 2.37072 52.0116 1.77553 51.1004 1.52644C50.1892 1.27736 49.2157 1.39442 48.3908 1.8523L46.4059 2.9303C46.0428 3.13132 45.6234 3.20891 45.2117 3.15124C44.8 3.09356 44.4187 2.90379 44.1259 2.61089L42.5163 1.02718C41.8394 0.36879 40.9294 0 39.9816 0C39.0337 0 38.1236 0.36879 37.4467 1.02718L35.7299 2.73067C35.4363 3.0219 35.0561 3.21153 34.6454 3.27145C34.2347 3.33138 33.8153 3.25843 33.4497 3.06339L31.3038 1.90554C30.4689 1.45939 29.4902 1.35872 28.5808 1.62544C27.6714 1.89217 26.905 2.50468 26.4487 3.32955L25.2818 5.44562C25.0795 5.80332 24.7677 6.08776 24.3915 6.25766C24.0153 6.42757 23.5943 6.47411 23.1896 6.39052L20.8156 5.8981C19.895 5.69843 18.9321 5.8655 18.1344 6.36333C17.3367 6.86117 16.7679 7.64994 16.5505 8.55981L16.0274 10.9154C15.9396 11.317 15.7242 11.68 15.4127 11.9508C15.1011 12.2216 14.7101 12.3858 14.2974 12.4193L11.8697 12.6056C10.9228 12.6771 10.0429 13.1176 9.42223 13.8308C8.80152 14.5439 8.49044 15.4719 8.55696 16.4119L8.73133 18.8074C8.76081 19.2195 8.65534 19.63 8.43057 19.9777C8.2058 20.3255 7.87368 20.5919 7.48393 20.7371L5.21736 21.5889C4.33015 21.9233 3.61226 22.5924 3.22028 23.45C2.82831 24.3077 2.794 25.2844 3.125 26.167L3.96997 28.4295C4.10506 28.8059 4.11824 29.2148 4.00762 29.5989C3.897 29.9831 3.66817 30.3234 3.35306 30.5722L1.4218 32.0228C1.04664 32.3042 0.730926 32.6561 0.492841 33.0585C0.254756 33.461 0.0988546 33.906 0.0340922 34.3682C-0.0306702 34.8304 -0.00295748 35.3007 0.115462 35.7523C0.233881 36.2039 0.440771 36.6279 0.724344 37.0002L2.17279 38.9299C2.41699 39.2623 2.54853 39.6631 2.54853 40.0745C2.54853 40.4858 2.41699 40.8866 2.17279 41.219L0.724344 43.1621C0.160153 43.9179 -0.0791344 44.8648 0.0591417 45.7954C0.197418 46.7259 0.701877 47.5641 1.46191 48.1261L3.40676 49.5768C3.74 49.8238 3.98384 50.1709 4.10225 50.5666C4.22066 50.9622 4.20731 51.3852 4.06394 51.7727L3.2324 54.0351C2.91129 54.9214 2.95504 55.8975 3.35421 56.752C3.75338 57.6064 4.47577 58.2704 5.36488 58.6L7.64487 59.4384C8.0323 59.583 8.36268 59.8473 8.58725 60.1924C8.81182 60.5374 8.91877 60.9449 8.89226 61.3548L8.7179 63.8435C8.65887 64.7812 8.97511 65.7042 9.59791 66.4119C10.2207 67.1196 11.0997 67.5549 12.0441 67.6232L14.4717 67.7829C14.8868 67.8121 15.2814 67.9727 15.5977 68.241C15.9139 68.5093 16.135 68.8711 16.2286 69.2734L16.7652 71.629C16.9824 72.5417 17.5532 73.3328 18.3539 73.831C19.1547 74.3292 20.1209 74.4943 21.0435 74.2907L23.4175 73.7717C23.8223 73.686 24.2442 73.7315 24.6209 73.9016C24.9976 74.0718 25.3092 74.3574 25.5099 74.7166L26.7036 76.8194C27.1732 77.6309 27.9465 78.2258 28.8555 78.475C29.7646 78.7242 30.7359 78.6075 31.5587 78.1502L33.5437 77.0722C33.9094 76.8723 34.3305 76.7954 34.7439 76.853C35.1574 76.9106 35.541 77.0995 35.8371 77.3916L37.4332 78.962C38.1068 79.6268 39.0182 80 39.9681 80C40.9181 80 41.8294 79.6268 42.5029 78.962L44.2331 77.2719C44.5245 76.9817 44.9025 76.7927 45.3109 76.7327C45.7192 76.6728 46.1362 76.7452 46.4998 76.9391L48.6457 78.0837C49.479 78.5309 50.4566 78.6336 51.3658 78.3694C52.275 78.1052 53.0423 77.4955 53.5009 76.673L54.6677 74.5569C54.8675 74.1937 55.181 73.9049 55.561 73.7344C55.941 73.5639 56.3666 73.5209 56.7734 73.612L59.1473 74.1044C60.066 74.3002 61.0254 74.1312 61.8201 73.6337C62.6148 73.1362 63.1816 72.3498 63.399 71.4427L63.9221 69.0871C64.0126 68.6844 64.2306 68.3211 64.5444 68.0504C64.8582 67.7798 65.2511 67.616 65.6656 67.5832L68.0798 67.3969C69.0268 67.3254 69.9066 66.8849 70.5273 66.1718C71.148 65.4586 71.4591 64.5307 71.3926 63.5907L71.2182 61.1951C71.1909 60.7834 71.2973 60.3738 71.5218 60.0265C71.7463 59.6792 72.0771 59.4125 72.4656 59.2654L74.7322 58.4136C75.6194 58.0792 76.3373 57.4102 76.7293 56.5525C77.1212 55.6948 77.1556 54.7181 76.8246 53.8355L75.9796 51.573C75.837 51.1867 75.8225 50.7653 75.9383 50.3703C76.0541 49.9752 76.2941 49.6273 76.6233 49.3771L78.5546 47.9132C78.9337 47.6337 79.2534 47.2825 79.4952 46.8799C79.737 46.4773 79.8961 46.0313 79.9634 45.5674C80.0307 45.1035 80.0049 44.631 79.8875 44.1771C79.77 43.7232 79.5631 43.2968 79.2789 42.9225V42.9225Z"
                      fill="#E31B23"
                    />
                  </svg>
                </div>
                <div className="cart-shippingOptionItemTile">Dine In</div>
              </div>
              <div
                className="cart-shippingOptionCon"
                onClick={() => {
                  setTogo(true);
                  GGCStoreFront.getInstance().setDineIn(false, () => {});
                }}
              >
                <div
                  className="cart-shippingOptionItem"
                  style={{
                    filter: !togo ? " grayscale(100%)  " : "",
                    opacity: !togo ? " .6" : "",
                  }}
                >
                  <img
                    src="\images\togo.png"
                    alt=""
                    className="cart-shippingOptionItemImg"
                  />
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="configurator-ingredientRing --2nd"
                  >
                    <path
                      d="M79.2789 42.9225L77.817 40.9795C77.5679 40.6516 77.4331 40.2522 77.4331 39.8416C77.4331 39.4309 77.5679 39.0315 77.817 38.7037L79.2521 36.7606C79.817 36.0027 80.0566 35.0536 79.9184 34.1209C79.7802 33.1882 79.2754 32.3477 78.5145 31.7832L76.5696 30.3459C76.2364 30.0989 75.9924 29.7518 75.874 29.3561C75.7556 28.9605 75.7691 28.5374 75.9125 28.15L76.744 25.8876C77.0658 25.003 77.024 24.0283 76.6274 23.1741C76.2309 22.3199 75.5116 21.6549 74.625 21.3227L72.3448 20.4843C71.9549 20.3419 71.6217 20.0785 71.3946 19.7333C71.1674 19.3881 71.0586 18.9794 71.0841 18.5678L71.2451 16.159C71.304 15.2191 70.986 14.2943 70.3603 13.5862C69.7347 12.8781 68.8522 12.4443 67.9055 12.3794L65.4778 12.2064C65.0656 12.1793 64.6733 12.0209 64.3591 11.7547C64.0449 11.4885 63.8259 11.1288 63.7343 10.7291L63.1978 8.3735C62.9806 7.46078 62.4098 6.66971 61.6091 6.17154C60.8083 5.67337 59.842 5.5082 58.9194 5.71179L56.5455 6.23082C56.1388 6.31747 55.7147 6.27245 55.3357 6.10238C54.9567 5.93231 54.6427 5.64615 54.4397 5.28591L53.2594 3.18316C52.7872 2.37072 52.0116 1.77553 51.1004 1.52644C50.1892 1.27736 49.2157 1.39442 48.3908 1.8523L46.4059 2.9303C46.0428 3.13132 45.6234 3.20891 45.2117 3.15124C44.8 3.09356 44.4187 2.90379 44.1259 2.61089L42.5163 1.02718C41.8394 0.36879 40.9294 0 39.9816 0C39.0337 0 38.1236 0.36879 37.4467 1.02718L35.7299 2.73067C35.4363 3.0219 35.0561 3.21153 34.6454 3.27145C34.2347 3.33138 33.8153 3.25843 33.4497 3.06339L31.3038 1.90554C30.4689 1.45939 29.4902 1.35872 28.5808 1.62544C27.6714 1.89217 26.905 2.50468 26.4487 3.32955L25.2818 5.44562C25.0795 5.80332 24.7677 6.08776 24.3915 6.25766C24.0153 6.42757 23.5943 6.47411 23.1896 6.39052L20.8156 5.8981C19.895 5.69843 18.9321 5.8655 18.1344 6.36333C17.3367 6.86117 16.7679 7.64994 16.5505 8.55981L16.0274 10.9154C15.9396 11.317 15.7242 11.68 15.4127 11.9508C15.1011 12.2216 14.7101 12.3858 14.2974 12.4193L11.8697 12.6056C10.9228 12.6771 10.0429 13.1176 9.42223 13.8308C8.80152 14.5439 8.49044 15.4719 8.55696 16.4119L8.73133 18.8074C8.76081 19.2195 8.65534 19.63 8.43057 19.9777C8.2058 20.3255 7.87368 20.5919 7.48393 20.7371L5.21736 21.5889C4.33015 21.9233 3.61226 22.5924 3.22028 23.45C2.82831 24.3077 2.794 25.2844 3.125 26.167L3.96997 28.4295C4.10506 28.8059 4.11824 29.2148 4.00762 29.5989C3.897 29.9831 3.66817 30.3234 3.35306 30.5722L1.4218 32.0228C1.04664 32.3042 0.730926 32.6561 0.492841 33.0585C0.254756 33.461 0.0988546 33.906 0.0340922 34.3682C-0.0306702 34.8304 -0.00295748 35.3007 0.115462 35.7523C0.233881 36.2039 0.440771 36.6279 0.724344 37.0002L2.17279 38.9299C2.41699 39.2623 2.54853 39.6631 2.54853 40.0745C2.54853 40.4858 2.41699 40.8866 2.17279 41.219L0.724344 43.1621C0.160153 43.9179 -0.0791344 44.8648 0.0591417 45.7954C0.197418 46.7259 0.701877 47.5641 1.46191 48.1261L3.40676 49.5768C3.74 49.8238 3.98384 50.1709 4.10225 50.5666C4.22066 50.9622 4.20731 51.3852 4.06394 51.7727L3.2324 54.0351C2.91129 54.9214 2.95504 55.8975 3.35421 56.752C3.75338 57.6064 4.47577 58.2704 5.36488 58.6L7.64487 59.4384C8.0323 59.583 8.36268 59.8473 8.58725 60.1924C8.81182 60.5374 8.91877 60.9449 8.89226 61.3548L8.7179 63.8435C8.65887 64.7812 8.97511 65.7042 9.59791 66.4119C10.2207 67.1196 11.0997 67.5549 12.0441 67.6232L14.4717 67.7829C14.8868 67.8121 15.2814 67.9727 15.5977 68.241C15.9139 68.5093 16.135 68.8711 16.2286 69.2734L16.7652 71.629C16.9824 72.5417 17.5532 73.3328 18.3539 73.831C19.1547 74.3292 20.1209 74.4943 21.0435 74.2907L23.4175 73.7717C23.8223 73.686 24.2442 73.7315 24.6209 73.9016C24.9976 74.0718 25.3092 74.3574 25.5099 74.7166L26.7036 76.8194C27.1732 77.6309 27.9465 78.2258 28.8555 78.475C29.7646 78.7242 30.7359 78.6075 31.5587 78.1502L33.5437 77.0722C33.9094 76.8723 34.3305 76.7954 34.7439 76.853C35.1574 76.9106 35.541 77.0995 35.8371 77.3916L37.4332 78.962C38.1068 79.6268 39.0182 80 39.9681 80C40.9181 80 41.8294 79.6268 42.5029 78.962L44.2331 77.2719C44.5245 76.9817 44.9025 76.7927 45.3109 76.7327C45.7192 76.6728 46.1362 76.7452 46.4998 76.9391L48.6457 78.0837C49.479 78.5309 50.4566 78.6336 51.3658 78.3694C52.275 78.1052 53.0423 77.4955 53.5009 76.673L54.6677 74.5569C54.8675 74.1937 55.181 73.9049 55.561 73.7344C55.941 73.5639 56.3666 73.5209 56.7734 73.612L59.1473 74.1044C60.066 74.3002 61.0254 74.1312 61.8201 73.6337C62.6148 73.1362 63.1816 72.3498 63.399 71.4427L63.9221 69.0871C64.0126 68.6844 64.2306 68.3211 64.5444 68.0504C64.8582 67.7798 65.2511 67.616 65.6656 67.5832L68.0798 67.3969C69.0268 67.3254 69.9066 66.8849 70.5273 66.1718C71.148 65.4586 71.4591 64.5307 71.3926 63.5907L71.2182 61.1951C71.1909 60.7834 71.2973 60.3738 71.5218 60.0265C71.7463 59.6792 72.0771 59.4125 72.4656 59.2654L74.7322 58.4136C75.6194 58.0792 76.3373 57.4102 76.7293 56.5525C77.1212 55.6948 77.1556 54.7181 76.8246 53.8355L75.9796 51.573C75.837 51.1867 75.8225 50.7653 75.9383 50.3703C76.0541 49.9752 76.2941 49.6273 76.6233 49.3771L78.5546 47.9132C78.9337 47.6337 79.2534 47.2825 79.4952 46.8799C79.737 46.4773 79.8961 46.0313 79.9634 45.5674C80.0307 45.1035 80.0049 44.631 79.8875 44.1771C79.77 43.7232 79.5631 43.2968 79.2789 42.9225V42.9225Z"
                      fill="#E31B23"
                    />
                  </svg>
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="configurator-ingredientRing"
                  >
                    <path
                      d="M79.2789 42.9225L77.817 40.9795C77.5679 40.6516 77.4331 40.2522 77.4331 39.8416C77.4331 39.4309 77.5679 39.0315 77.817 38.7037L79.2521 36.7606C79.817 36.0027 80.0566 35.0536 79.9184 34.1209C79.7802 33.1882 79.2754 32.3477 78.5145 31.7832L76.5696 30.3459C76.2364 30.0989 75.9924 29.7518 75.874 29.3561C75.7556 28.9605 75.7691 28.5374 75.9125 28.15L76.744 25.8876C77.0658 25.003 77.024 24.0283 76.6274 23.1741C76.2309 22.3199 75.5116 21.6549 74.625 21.3227L72.3448 20.4843C71.9549 20.3419 71.6217 20.0785 71.3946 19.7333C71.1674 19.3881 71.0586 18.9794 71.0841 18.5678L71.2451 16.159C71.304 15.2191 70.986 14.2943 70.3603 13.5862C69.7347 12.8781 68.8522 12.4443 67.9055 12.3794L65.4778 12.2064C65.0656 12.1793 64.6733 12.0209 64.3591 11.7547C64.0449 11.4885 63.8259 11.1288 63.7343 10.7291L63.1978 8.3735C62.9806 7.46078 62.4098 6.66971 61.6091 6.17154C60.8083 5.67337 59.842 5.5082 58.9194 5.71179L56.5455 6.23082C56.1388 6.31747 55.7147 6.27245 55.3357 6.10238C54.9567 5.93231 54.6427 5.64615 54.4397 5.28591L53.2594 3.18316C52.7872 2.37072 52.0116 1.77553 51.1004 1.52644C50.1892 1.27736 49.2157 1.39442 48.3908 1.8523L46.4059 2.9303C46.0428 3.13132 45.6234 3.20891 45.2117 3.15124C44.8 3.09356 44.4187 2.90379 44.1259 2.61089L42.5163 1.02718C41.8394 0.36879 40.9294 0 39.9816 0C39.0337 0 38.1236 0.36879 37.4467 1.02718L35.7299 2.73067C35.4363 3.0219 35.0561 3.21153 34.6454 3.27145C34.2347 3.33138 33.8153 3.25843 33.4497 3.06339L31.3038 1.90554C30.4689 1.45939 29.4902 1.35872 28.5808 1.62544C27.6714 1.89217 26.905 2.50468 26.4487 3.32955L25.2818 5.44562C25.0795 5.80332 24.7677 6.08776 24.3915 6.25766C24.0153 6.42757 23.5943 6.47411 23.1896 6.39052L20.8156 5.8981C19.895 5.69843 18.9321 5.8655 18.1344 6.36333C17.3367 6.86117 16.7679 7.64994 16.5505 8.55981L16.0274 10.9154C15.9396 11.317 15.7242 11.68 15.4127 11.9508C15.1011 12.2216 14.7101 12.3858 14.2974 12.4193L11.8697 12.6056C10.9228 12.6771 10.0429 13.1176 9.42223 13.8308C8.80152 14.5439 8.49044 15.4719 8.55696 16.4119L8.73133 18.8074C8.76081 19.2195 8.65534 19.63 8.43057 19.9777C8.2058 20.3255 7.87368 20.5919 7.48393 20.7371L5.21736 21.5889C4.33015 21.9233 3.61226 22.5924 3.22028 23.45C2.82831 24.3077 2.794 25.2844 3.125 26.167L3.96997 28.4295C4.10506 28.8059 4.11824 29.2148 4.00762 29.5989C3.897 29.9831 3.66817 30.3234 3.35306 30.5722L1.4218 32.0228C1.04664 32.3042 0.730926 32.6561 0.492841 33.0585C0.254756 33.461 0.0988546 33.906 0.0340922 34.3682C-0.0306702 34.8304 -0.00295748 35.3007 0.115462 35.7523C0.233881 36.2039 0.440771 36.6279 0.724344 37.0002L2.17279 38.9299C2.41699 39.2623 2.54853 39.6631 2.54853 40.0745C2.54853 40.4858 2.41699 40.8866 2.17279 41.219L0.724344 43.1621C0.160153 43.9179 -0.0791344 44.8648 0.0591417 45.7954C0.197418 46.7259 0.701877 47.5641 1.46191 48.1261L3.40676 49.5768C3.74 49.8238 3.98384 50.1709 4.10225 50.5666C4.22066 50.9622 4.20731 51.3852 4.06394 51.7727L3.2324 54.0351C2.91129 54.9214 2.95504 55.8975 3.35421 56.752C3.75338 57.6064 4.47577 58.2704 5.36488 58.6L7.64487 59.4384C8.0323 59.583 8.36268 59.8473 8.58725 60.1924C8.81182 60.5374 8.91877 60.9449 8.89226 61.3548L8.7179 63.8435C8.65887 64.7812 8.97511 65.7042 9.59791 66.4119C10.2207 67.1196 11.0997 67.5549 12.0441 67.6232L14.4717 67.7829C14.8868 67.8121 15.2814 67.9727 15.5977 68.241C15.9139 68.5093 16.135 68.8711 16.2286 69.2734L16.7652 71.629C16.9824 72.5417 17.5532 73.3328 18.3539 73.831C19.1547 74.3292 20.1209 74.4943 21.0435 74.2907L23.4175 73.7717C23.8223 73.686 24.2442 73.7315 24.6209 73.9016C24.9976 74.0718 25.3092 74.3574 25.5099 74.7166L26.7036 76.8194C27.1732 77.6309 27.9465 78.2258 28.8555 78.475C29.7646 78.7242 30.7359 78.6075 31.5587 78.1502L33.5437 77.0722C33.9094 76.8723 34.3305 76.7954 34.7439 76.853C35.1574 76.9106 35.541 77.0995 35.8371 77.3916L37.4332 78.962C38.1068 79.6268 39.0182 80 39.9681 80C40.9181 80 41.8294 79.6268 42.5029 78.962L44.2331 77.2719C44.5245 76.9817 44.9025 76.7927 45.3109 76.7327C45.7192 76.6728 46.1362 76.7452 46.4998 76.9391L48.6457 78.0837C49.479 78.5309 50.4566 78.6336 51.3658 78.3694C52.275 78.1052 53.0423 77.4955 53.5009 76.673L54.6677 74.5569C54.8675 74.1937 55.181 73.9049 55.561 73.7344C55.941 73.5639 56.3666 73.5209 56.7734 73.612L59.1473 74.1044C60.066 74.3002 61.0254 74.1312 61.8201 73.6337C62.6148 73.1362 63.1816 72.3498 63.399 71.4427L63.9221 69.0871C64.0126 68.6844 64.2306 68.3211 64.5444 68.0504C64.8582 67.7798 65.2511 67.616 65.6656 67.5832L68.0798 67.3969C69.0268 67.3254 69.9066 66.8849 70.5273 66.1718C71.148 65.4586 71.4591 64.5307 71.3926 63.5907L71.2182 61.1951C71.1909 60.7834 71.2973 60.3738 71.5218 60.0265C71.7463 59.6792 72.0771 59.4125 72.4656 59.2654L74.7322 58.4136C75.6194 58.0792 76.3373 57.4102 76.7293 56.5525C77.1212 55.6948 77.1556 54.7181 76.8246 53.8355L75.9796 51.573C75.837 51.1867 75.8225 50.7653 75.9383 50.3703C76.0541 49.9752 76.2941 49.6273 76.6233 49.3771L78.5546 47.9132C78.9337 47.6337 79.2534 47.2825 79.4952 46.8799C79.737 46.4773 79.8961 46.0313 79.9634 45.5674C80.0307 45.1035 80.0049 44.631 79.8875 44.1771C79.77 43.7232 79.5631 43.2968 79.2789 42.9225V42.9225Z"
                      fill="#E31B23"
                    />
                  </svg>
                </div>
                <div className="cart-shippingOptionItemTile">To Go</div>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="configurator-buttonCon --cart">
        <Link
          to="/Configurator"
          style={{
            pointerEvents: contextReact.cartCount > 6 ? "none" : "all",
          }}
        >
          <Button
            text="Make More"
            left={true}
            disabled={contextReact.cartCount > 6 ? true : false}
            passClick={() => {
              contextReact.resetConfiguratorCart();
              contextReact.updater("swiperStep", 1);
            }}
          />
        </Link>

        <Button
          text="start from scratch"
          extraClass="--center"
          center={true}
          left={true}
          passClick={() => {
            setTimeout(() => {
              setPopupNotice(true);
            }, 100);
          }}
        />

        {/* <Link to={"/Checkout"}> */}
        <Button
          disabled={contextReact.cart.length > 0 ? false : true}
          text="Check out"
          passClick={() => {
            if (togo === null) {
              GGCStoreFront.getInstance().setDineIn(false, () => {});
            }
            if (cardReader) {
              history.push(`/Checkout`);
              //  history.push(`/Checkout/shopify`);
            } else {
              // history.push(`/Checkout/shopify`);
              // history.push(`/TestStripe`);
              window.location.href = contextReact.shopifyCart?.invoiceUrl;
            }
          }}
        />
        {/* </Link> */}
      </div>
      <NoticePopUP
        title={`Are you sure you want to start from scratch?`}
        forward="No"
        back="Yes"
        passedState={popupNotice}
        passedStateFunction={() => {
          setPopupNotice(false);
        }}
        forwardFunction={() => {
          setPopupNotice(false);
        }}
        backFunction={() => {
          setPopupNotice(false);
          contextReact.updater("swiperStep", 1);
          history.push("/");
          setTimeout(() => {
            contextReact.flushCart();
            contextReact.updater("swiperStep", 1);
            setTimeout(() => {
              contextReact.updateCartCount();
            }, 100);
          }, 100);
        }}
      />
    </div>
  );
}

function CartItem({ name, shell, sweets, addIns, addOns, count, index }: any) {
  const contextReact = useContext(ContextData);
  const [popup, setPopup] = useState(null);
  const { height, width }: any = useWindowDimensions();
  const [popupNotice, setPopupNotice] = useState(false);
  const [cartCollapsed, setcartCollapsed] = useState(
    index === contextReact.cart.length - 1 || contextReact.cart.length === 1
      ? false
      : true
  );
  let extraCost: any = getExtraCost(index, contextReact);

  return (
    <div className="cart-item ">
      <NoticePopUP
        title={`Are you sure you want to delete ${name}'s combination?`}
        forward="Delete"
        back="cancel"
        passedState={popupNotice}
        passedStateFunction={() => {
          setPopupNotice(false);
        }}
        forwardFunction={() => {
          setPopupNotice(false);
          contextReact.removeGooGoo(index);
        }}
        backFunction={() => {
          setPopupNotice(false);
        }}
      />
      <div className="cart-leftRule">
        <div className="cart-leftInnerRule"></div>
        <div className="cart-sync"></div>
      </div>
      <div className="cart-itemHeader">
        <div
          className="cart-x"
          onClick={() => {
            setPopupNotice(true);
          }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="18"
              y="15.0703"
              width="3.55211"
              height="21.3127"
              rx="1.77606"
              transform="rotate(135 18 15.0703)"
              fill="#7299C6"
            />
            <rect
              x="2.51172"
              y="17.9995"
              width="3.55211"
              height="21.3127"
              rx="1.77606"
              transform="rotate(-135 2.51172 17.9995)"
              fill="#7299C6"
            />
          </svg>
        </div>
        <div
          className="cart-expandIcon"
          onClick={() => {
            setcartCollapsed(!cartCollapsed);
          }}
        >
          <svg
            width="21"
            height="12"
            viewBox="0 0 21 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
              transform: cartCollapsed ? "rotate(0deg)" : "rotate(180deg)",
            }}
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M18.4056 11.2C17.8564 11.2046 17.3259 11.0044 16.9216 10.64L10.4943 4.69441L4.07846 10.633C3.67468 10.9977 3.14569 11.2002 2.59661 11.2002C2.04753 11.2002 1.51855 10.9977 1.11477 10.633C0.920975 10.4584 0.766277 10.2462 0.660458 10.0099C0.554638 9.77363 0.5 9.5184 0.5 9.26036C0.5 9.00232 0.554638 8.74709 0.660458 8.51081C0.766278 8.27454 0.920975 8.06236 1.11477 7.8877L9.02033 0.570141C9.42271 0.203801 9.95156 0.000196488 10.5007 0.000196536C11.0499 0.000196584 11.5788 0.203801 11.9812 0.570141L19.8839 7.8877C20.078 8.06213 20.2331 8.27424 20.3392 8.51054C20.4452 8.74685 20.5 9.00219 20.5 9.26036C20.5 9.51852 20.4452 9.77387 20.3392 10.0102C20.2331 10.2465 20.078 10.4586 19.8839 10.633C19.4826 10.9993 18.954 11.2021 18.4056 11.2Z"
              fill="#7299C6"
            />
          </svg>
        </div>
        <div className="cart-name">{name}</div>
      </div>
      <div
        className="cart-ingredients"
        style={{
          maxHeight: cartCollapsed ? "0px" : "",
          // transform: cartCollapsed ? "translateY(-100%)" : "",
          marginTop: cartCollapsed ? "-3px" : "",
        }}
      >
        <div className="cart-lineItem">
          <EditModelPopup
            active={popup === 1 ? true : false}
            items={contextReact.ingredients.shells}
            index={index}
            step="1"
            title={`Choose ${width > 833 ? "your" : "a"} chocolate shell`}
            IngredientType="shell"
            copy=" Choose whether you want your Goo Goo draped in Dark or Milk Chocolate."
            stateFunction={(i: number) => {
              setPopup(i);
            }}
          />
          <div
            className="cart-rowSmall"
            onClick={() => {
              contextReact.createTempGooGoo(index);
              setPopup(1);
            }}
          >
            <EditIcon />
            <p>Chocolate Shell</p>
          </div>
          <div className="cart-rowBig">
            {shell.map((element: any) => {
              return (
                <p>
                  {element.title}{" "}
                  {parseFloat(element.price) > 5.5 ? (
                    <p className="cart-extra">
                      {/* +${parseFloat(element.price).toFixed(2)} */}
                    </p>
                  ) : null}{" "}
                </p>
              );
            })}
          </div>
        </div>
        <div className="cart-lineItem">
          <EditModelPopup
            active={popup === 2 ? true : false}
            items={contextReact.ingredients.sweets}
            index={index}
            step="2"
            title="Choose sweet fillings"
            IngredientType="sweets"
            copy=" Start building with two layers of gooey goodness."
            stateFunction={(i: number) => {
              setPopup(i);
            }}
          />
          <div
            className="cart-rowSmall"
            onClick={() => {
              contextReact.createTempGooGoo(index);
              setPopup(2);
            }}
          >
            <EditIcon />
            <p>Sweet Fillings</p>
          </div>
          <div className="cart-rowBig">
            {sweets.map((element: any) => {
              return (
                <p>
                  {element.title}{" "}
                  {parseFloat(element.price) > 0 ? (
                    <p className="cart-extra">
                      +${parseFloat(element.price).toFixed(2)}
                    </p>
                  ) : null}
                </p>
              );
            })}
          </div>
        </div>
        <div className="cart-lineItem">
          <EditModelPopup
            active={popup === 3 ? true : false}
            items={contextReact.ingredients.addIns}
            index={index}
            step="3"
            title="Pick three add-ins"
            IngredientType="addIns"
            copy="Feel free to double or triple your favorite add-in."
            stateFunction={(i: number) => {
              setPopup(i);
            }}
          />
          <div
            className="cart-rowSmall"
            onClick={() => {
              contextReact.createTempGooGoo(index);
              setPopup(3);
            }}
          >
            <EditIcon />
            <p>Add-Ins</p>
          </div>
          <div className="cart-rowBig">
            {addIns.length < 1 ? (
              <p>none</p>
            ) : (
              addIns.map((element: any) => {
                return (
                  <p>
                    {element.title}{" "}
                    {parseFloat(element.price) > 0 ? (
                      <p className="cart-extra">
                        +${parseFloat(element.price).toFixed(2)}
                      </p>
                    ) : null}{" "}
                  </p>
                );
              })
            )}
          </div>
        </div>
        <div className="cart-lineItem">
          <EditModelPopup
            active={popup === 4 ? true : false}
            items={contextReact.ingredients.addOns}
            index={index}
            step={
              <svg
                width="38"
                height="37"
                viewBox="0 0 38 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.0489 0.927049C18.3483 0.00573802 19.6517 0.00574017 19.9511 0.927051L23.7148 12.5106C23.8487 12.9227 24.2326 13.2016 24.6659 13.2016H36.8456C37.8143 13.2016 38.2171 14.4412 37.4333 15.0106L27.5798 22.1697C27.2293 22.4243 27.0826 22.8757 27.2165 23.2877L30.9802 34.8713C31.2796 35.7926 30.2251 36.5588 29.4414 35.9894L19.5878 28.8303C19.2373 28.5757 18.7627 28.5757 18.4122 28.8303L8.55862 35.9894C7.77491 36.5588 6.72043 35.7926 7.01978 34.8713L10.7835 23.2877C10.9174 22.8757 10.7707 22.4243 10.4202 22.1697L0.566653 15.0106C-0.217061 14.4412 0.185717 13.2016 1.15444 13.2016H13.3342C13.7674 13.2016 14.1513 12.9227 14.2852 12.5106L18.0489 0.927049Z"
                  fill="white"
                />
              </svg>
            }
            title="Footer Add-On"
            IngredientType="addOns"
            copy={
              <p>
                Select an extra layer of flavor to make your
                {width < 809 ? <br /> : ""}Goo Goo even better.
              </p>
            }
            stateFunction={(i: number) => {
              setPopup(i);
            }}
          />
          <div
            className="cart-rowSmall"
            onClick={() => {
              contextReact.createTempGooGoo(index);
              setPopup(4);
            }}
          >
            <EditIcon />
            <p>Footer Add-Ons</p>
          </div>
          <div className="cart-rowBig">
            {addOns.length < 1 ? (
              <p>None</p>
            ) : (
              addOns.map((element: any) => {
                console.log(element);
                return (
                  <p>
                    {element.title}

                    {parseFloat(element.price) > 0 ? (
                      <p className="cart-extra">
                        +${parseFloat(element.price).toFixed(2)}
                      </p>
                    ) : null}
                  </p>
                );
              })
            )}
          </div>
        </div>
      </div>
      <div className="cart-footer">
        <div className="cart-rowSmall --priceTitle">
          <p className="">Quantity & Cost</p>
        </div>
        <div className="cart-rowBig --flex">
          <div className="cart-countCon">
            <div
              className="cart-contMinus"
              onClick={() => {
                if (count === 1) {
                  setPopupNotice(true);
                } else {
                  contextReact.incrementGooGoo(index, "--");
                }
              }}
            >
              <svg
                width="16"
                height="3"
                viewBox="0 0 16 3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="15.4995"
                  y="0.16626"
                  width="2.5"
                  height="15"
                  rx="1.25"
                  transform="rotate(90 15.4995 0.16626)"
                  fill="#FFFDEF"
                />
              </svg>
            </div>
            <div className="cart-countText">{count}</div>
            <div
              className="cart-countPluse"
              onClick={() => {
                contextReact.incrementGooGoo(index, "++");
              }}
              style={{
                pointerEvents: contextReact.cartCount > 6 ? "none" : "all",
                background: contextReact.cartCount > 6 ? "#E8E6DF" : "",
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="15.5459"
                  y="6.3335"
                  width="2.5"
                  height="15"
                  rx="1.25"
                  transform="rotate(90 15.5459 6.3335)"
                  fill="#FFFDEF"
                />
                <rect
                  x="9.29688"
                  y="15.5"
                  width="2.5"
                  height="15"
                  rx="1.25"
                  transform="rotate(-180 9.29688 15.5)"
                  fill="#FFFDEF"
                />
              </svg>
            </div>
          </div>

          <div className="cart-rowBigPrice">
            <p>
              $
              {contextReact.cart && contextReact.cart[index]
                ? (
                    Math.round(
                      (parseFloat(contextReact.cart[index].shell[0].price) +
                        parseFloat(extraCost)) *
                        contextReact.cart[index].count *
                        100
                    ) / 100
                  ).toFixed(2)
                : ""}
              {/* {Math.round(contextReact.globalVariables.price * count * 100) /
                100} */}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function precise(x: any) {
  return Number.parseFloat(x).toPrecision(4);
}

function EmptyState({}: any) {
  return (
    <div className="cart-empty">
      <h1 className="cart-emptyTitle">Empty</h1>
    </div>
  );
}

function EditIcon() {
  return (
    <svg
      className="cart-editButton"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.8149 1.2398C19.68 1.09161 19.4904 1.00504 19.2901 1.00021C19.0898 0.995383 18.8962 1.07271 18.7544 1.21422L18.1894 1.77645C18.0468 1.91913 18.0468 2.15034 18.1894 2.29302L18.7073 2.81003C18.7759 2.87893 18.8691 2.91765 18.9663 2.91765C19.0635 2.91765 19.1567 2.87893 19.2253 2.81003L19.7761 2.26196C20.0547 1.98381 20.0807 1.53073 19.8149 1.2398ZM11.207 3.92358C11.6106 3.92358 11.9377 4.25076 11.9377 4.65435C11.9377 5.05313 11.6183 5.37731 11.2214 5.38497L11.207 5.38511H3.55768C2.95835 5.38511 2.47136 5.86611 2.46168 6.46314L2.46153 6.48126V17.4428C2.46153 18.0421 2.94253 18.5291 3.53956 18.5388L3.55768 18.5389H14.5192C14.8099 18.5389 15.0887 18.4234 15.2943 18.2179C15.4949 18.0172 15.6098 17.7467 15.6151 17.4635L15.6153 17.4428V9.03895C15.6153 8.63535 15.9425 8.30818 16.3461 8.30818C16.7449 8.30818 17.0691 8.62761 17.0767 9.02456L17.0769 9.03895V17.4428C17.0769 18.1211 16.8074 18.7717 16.3277 19.2513C15.855 19.724 15.2163 19.9926 14.5487 20.0003L14.5192 20.0004H3.55768C2.15924 20.0004 1.02293 18.8781 1.00034 17.4851L1 17.4428V6.48126C1 5.08282 2.12233 3.94651 3.51539 3.92392L3.55768 3.92358H11.207ZM8.80319 11.1476L17.0481 2.91738C17.2085 2.75739 17.4682 2.75739 17.6286 2.91738L18.083 3.3741C18.2415 3.53427 18.2415 3.79216 18.083 3.95232L9.85276 12.1981C9.80297 12.2481 9.74116 12.2844 9.67326 12.3036L8.53829 12.685C8.47551 12.7036 8.40757 12.6863 8.36126 12.64C8.31496 12.5937 8.29771 12.5258 8.31632 12.463L8.69769 11.3271C8.71687 11.2592 8.75321 11.1974 8.80319 11.1476Z"
        fill="#7299C6"
      />
      <path
        d="M19.2901 1.00021L19.3022 0.500359L19.2901 1.00021ZM19.8149 1.2398L19.4451 1.57634L19.4458 1.57705L19.8149 1.2398ZM18.7544 1.21422L19.1071 1.56863L19.1075 1.56819L18.7544 1.21422ZM18.1894 1.77645L17.8367 1.42204L17.8357 1.42302L18.1894 1.77645ZM18.1894 2.29302L17.8357 2.64645L17.8361 2.64688L18.1894 2.29302ZM18.7073 2.81003L19.0617 2.4573L19.0606 2.45617L18.7073 2.81003ZM19.2253 2.81003L18.8726 2.4556L18.8709 2.45731L19.2253 2.81003ZM19.7761 2.26196L20.1287 2.61639L20.1293 2.6158L19.7761 2.26196ZM11.2214 5.38497L11.2262 5.88497L11.231 5.88488L11.2214 5.38497ZM11.207 5.38511V5.88514L11.2118 5.88509L11.207 5.38511ZM2.46168 6.46314L1.96173 6.45503L1.9617 6.45909L2.46168 6.46314ZM2.46153 6.48126L1.96153 6.47721V6.48126H2.46153ZM3.53956 18.5388L3.53145 19.0387L3.5355 19.0387L3.53956 18.5388ZM3.55768 18.5389L3.55363 19.0389H3.55768V18.5389ZM15.2943 18.2179L15.6478 18.5714L15.6478 18.5714L15.2943 18.2179ZM15.6151 17.4635L16.1151 17.473L16.1151 17.4682L15.6151 17.4635ZM15.6153 17.4428L16.1153 17.4475V17.4428H15.6153ZM17.0767 9.02456L17.5767 9.01979L17.5766 9.01491L17.0767 9.02456ZM17.0769 9.03895H17.5769L17.5768 9.03417L17.0769 9.03895ZM16.3277 19.2513L16.6813 19.6049L16.3277 19.2513ZM14.5487 20.0003L14.5515 20.5003L14.5544 20.5002L14.5487 20.0003ZM14.5192 20.0004V20.5004L14.5221 20.5004L14.5192 20.0004ZM1.00034 17.4851L0.500343 17.4891L0.500408 17.4932L1.00034 17.4851ZM1 17.4428H0.499984L0.500016 17.4468L1 17.4428ZM3.51539 3.92392L3.51134 3.42392L3.50728 3.42399L3.51539 3.92392ZM3.55768 3.92358V3.42356L3.55363 3.4236L3.55768 3.92358ZM17.0481 2.91738L16.695 2.56333L16.6948 2.56351L17.0481 2.91738ZM8.80319 11.1476L9.15603 11.5019L9.15643 11.5015L8.80319 11.1476ZM17.6286 2.91738L17.983 2.56471L17.9816 2.56333L17.6286 2.91738ZM18.083 3.3741L18.4385 3.02244L18.4375 3.02144L18.083 3.3741ZM18.083 3.95232L18.4369 4.30555L18.4385 4.30399L18.083 3.95232ZM9.85276 12.1981L9.49887 11.8449L9.49849 11.8453L9.85276 12.1981ZM9.67326 12.3036L9.53733 11.8224L9.52558 11.8258L9.51401 11.8296L9.67326 12.3036ZM8.53829 12.685L8.68039 13.1644L8.68902 13.1618L8.69755 13.1589L8.53829 12.685ZM8.36126 12.64L8.00771 12.9936L8.00771 12.9936L8.36126 12.64ZM8.31632 12.463L7.84232 12.3039L7.83948 12.3123L7.83694 12.3209L8.31632 12.463ZM8.69769 11.3271L9.17169 11.4863L9.17555 11.4747L9.17886 11.4631L8.69769 11.3271ZM19.278 1.50007C19.3418 1.50161 19.4022 1.52916 19.4451 1.57634L20.1847 0.903257C19.9579 0.654056 19.639 0.508483 19.3022 0.500359L19.278 1.50007ZM19.1075 1.56819C19.1527 1.52315 19.2143 1.49853 19.278 1.50007L19.3022 0.500359C18.9653 0.492235 18.6398 0.622267 18.4012 0.860245L19.1075 1.56819ZM18.5421 2.13087L19.1071 1.56863L18.4017 0.859809L17.8367 1.42204L18.5421 2.13087ZM18.5431 1.93958C18.5956 1.99214 18.5956 2.07733 18.5431 2.12989L17.8357 1.42302C17.498 1.76092 17.498 2.30855 17.8357 2.64645L18.5431 1.93958ZM19.0606 2.45617L18.5426 1.93915L17.8361 2.64688L18.3541 3.1639L19.0606 2.45617ZM18.9663 2.41765C19.0021 2.41765 19.0364 2.43192 19.0617 2.4573L18.3529 3.16276C18.5154 3.32593 18.7361 3.41765 18.9663 3.41765V2.41765ZM18.8709 2.45731C18.8961 2.43192 18.9305 2.41765 18.9663 2.41765V3.41765C19.1965 3.41765 19.4172 3.32593 19.5796 3.16276L18.8709 2.45731ZM19.4234 1.90752L18.8726 2.4556L19.5779 3.16447L20.1287 2.61639L19.4234 1.90752ZM19.4458 1.57705C19.5182 1.65635 19.5259 1.80516 19.4228 1.90812L20.1293 2.6158C20.5834 2.16246 20.6432 1.40512 20.184 0.902539L19.4458 1.57705ZM12.4377 4.65435C12.4377 3.97461 11.8867 3.42358 11.207 3.42358V4.42358C11.3344 4.42358 11.4377 4.5269 11.4377 4.65435H12.4377ZM11.231 5.88488C11.8998 5.87197 12.4377 5.32604 12.4377 4.65435H11.4377C11.4377 4.78022 11.3369 4.88265 11.2117 4.88507L11.231 5.88488ZM11.2118 5.88509L11.2262 5.88495L11.2165 4.885L11.2022 4.88514L11.2118 5.88509ZM3.55768 5.88511H11.207V4.88511H3.55768V5.88511ZM2.96161 6.47124C2.96688 6.14672 3.23178 5.88511 3.55768 5.88511V4.88511C2.68492 4.88511 1.97584 5.5855 1.96175 6.45503L2.96161 6.47124ZM2.96152 6.48531L2.96166 6.46719L1.9617 6.45909L1.96155 6.47721L2.96152 6.48531ZM2.96153 17.4428V6.48126H1.96153V17.4428H2.96153ZM3.54766 18.0388C3.22314 18.0336 2.96153 17.7687 2.96153 17.4428H1.96153C1.96153 18.3155 2.66192 19.0246 3.53145 19.0387L3.54766 18.0388ZM3.56173 18.0389L3.54361 18.0388L3.5355 19.0387L3.55363 19.0389L3.56173 18.0389ZM14.5192 18.0389H3.55768V19.0389H14.5192V18.0389ZM14.9407 17.8643C14.8289 17.9761 14.6773 18.0389 14.5192 18.0389V19.0389C14.9425 19.0389 15.3485 18.8707 15.6478 18.5714L14.9407 17.8643ZM15.1152 17.4541C15.1123 17.6081 15.0499 17.7552 14.9407 17.8643L15.6478 18.5714C15.94 18.2792 16.1072 17.8854 16.115 17.473L15.1152 17.4541ZM15.1153 17.438L15.1152 17.4588L16.1151 17.4682L16.1153 17.4475L15.1153 17.438ZM15.1153 9.03895V17.4428H16.1153V9.03895H15.1153ZM16.3461 7.80818C15.6664 7.80818 15.1153 8.35921 15.1153 9.03895H16.1153C16.1153 8.9115 16.2186 8.80818 16.3461 8.80818V7.80818ZM17.5766 9.01491C17.5637 8.34616 17.0178 7.80818 16.3461 7.80818V8.80818C16.472 8.80818 16.5744 8.90906 16.5768 9.03422L17.5766 9.01491ZM17.5768 9.03417L17.5767 9.01979L16.5767 9.02934L16.5769 9.04372L17.5768 9.03417ZM17.5769 17.4428V9.03895H16.5769V17.4428H17.5769ZM16.6813 19.6049C17.2547 19.0314 17.5769 18.2537 17.5769 17.4428H16.5769C16.5769 17.9885 16.3601 18.5119 15.9742 18.8978L16.6813 19.6049ZM14.5544 20.5002C15.3526 20.4911 16.1162 20.17 16.6813 19.6049L15.9742 18.8978C15.5939 19.2781 15.08 19.4941 14.5429 19.5003L14.5544 20.5002ZM14.5221 20.5004L14.5515 20.5003L14.5458 19.5003L14.5163 19.5004L14.5221 20.5004ZM3.55768 20.5004H14.5192V19.5004H3.55768V20.5004ZM0.500408 17.4932C0.527413 19.1587 1.88581 20.5004 3.55768 20.5004V19.5004C2.43267 19.5004 1.51845 18.5975 1.50028 17.4769L0.500408 17.4932ZM0.500016 17.4468L0.500359 17.4891L1.50033 17.481L1.49998 17.4387L0.500016 17.4468ZM0.5 6.48126V17.4428H1.5V6.48126H0.5ZM3.50728 3.42399C1.84172 3.45099 0.5 4.80939 0.5 6.48126H1.5C1.5 5.35625 2.40293 4.44203 3.52349 4.42386L3.50728 3.42399ZM3.55363 3.4236L3.51134 3.42394L3.51944 4.42391L3.56173 4.42356L3.55363 3.4236ZM11.207 3.42358H3.55768V4.42358H11.207V3.42358ZM16.6948 2.56351L8.44996 10.7938L9.15643 11.5015L17.4013 3.27124L16.6948 2.56351ZM17.9816 2.56333C17.6261 2.20874 17.0506 2.20874 16.695 2.56333L17.4011 3.27143C17.3664 3.30604 17.3102 3.30604 17.2755 3.27143L17.9816 2.56333ZM18.4375 3.02144L17.983 2.56471L17.2741 3.27004L17.7286 3.72677L18.4375 3.02144ZM18.4385 4.30399C18.7897 3.949 18.7897 3.37743 18.4385 3.02244L17.7276 3.72577C17.6933 3.69111 17.6933 3.63531 17.7276 3.60066L18.4385 4.30399ZM10.2066 12.5513L18.4369 4.30554L17.7291 3.5991L9.49887 11.8449L10.2066 12.5513ZM9.8092 12.7848C9.95968 12.7423 10.0967 12.6617 10.207 12.5509L9.49849 11.8453C9.50926 11.8344 9.52263 11.8266 9.53733 11.8224L9.8092 12.7848ZM8.69755 13.1589L9.83252 12.7776L9.51401 11.8296L8.37903 12.211L8.69755 13.1589ZM8.00771 12.9936C8.18367 13.1695 8.44182 13.2351 8.68039 13.1644L8.39619 12.2056C8.50919 12.1721 8.63147 12.2031 8.71481 12.2865L8.00771 12.9936ZM7.83694 12.3209C7.76622 12.5595 7.83175 12.8176 8.00771 12.9936L8.71482 12.2865C8.79816 12.3698 8.8292 12.4921 8.7957 12.6051L7.83694 12.3209ZM8.22369 11.168L7.84232 12.3039L8.79032 12.6221L9.17169 11.4863L8.22369 11.168ZM8.45036 10.7933C8.33957 10.9037 8.25904 11.0407 8.21653 11.1912L9.17886 11.4631C9.17471 11.4777 9.16684 11.4911 9.15603 11.5019L8.45036 10.7933Z"
        fill="#7299C6"
      />
    </svg>
  );
}

function EditModelPopup({
  active,
  step,
  title,
  IngredientType,
  copy,
  items,
  index,
  stateFunction,
}: any) {
  const contextReact: any = useContext(ContextData);
  console.log(index);
  return (
    <div
      className="cart-modelBG configurator-backgroundModel"
      style={{
        pointerEvents: active ? "all" : "none",
        opacity: active ? "1" : "0",
      }}
    >
      <ConfiguratorSlide
        step={step}
        title={title}
        IngredientType={IngredientType}
        copy={copy}
        items={items}
        swiper={null}
        forward="Save"
        back="Cancel"
        modelModeTarget={index}
        modelModeFunction={() => {
          stateFunction(0);
          contextReact.resetConfiguratorCart();
        }}
        modelModeFunctionBack={() => {
          stateFunction(0);
          contextReact.restoreTempGooGoo(index);
        }}
        active={active}
      >
        <div
          className="cart-modelX"
          onClick={() => {
            stateFunction(0);
            contextReact.restoreTempGooGoo(index);
          }}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="18"
              y="15.0703"
              width="3.55211"
              height="21.3127"
              rx="1.77606"
              transform="rotate(135 18 15.0703)"
              fill="#7299C6"
            />
            <rect
              x="2.51172"
              y="17.9995"
              width="3.55211"
              height="21.3127"
              rx="1.77606"
              transform="rotate(-135 2.51172 17.9995)"
              fill="#7299C6"
            />
          </svg>
        </div>
      </ConfiguratorSlide>
    </div>
  );
}

function CostSummary({ title }: any) {
  const contextReact: any = useContext(ContextData);
  const { height, width }: any = useWindowDimensions();

  return (
    <div className="cart-con --summary">
      {contextReact.isFetching ? (
        <Loader />
      ) : (
        <>
          {/* <Loader /> */}
          <div className="cart-item">
            <div className="cart-leftRule">
              <div className="cart-leftInnerRule --summary"></div>
              <div className="cart-sync"></div>
            </div>
            <div className="cart-itemHeader --summary">
              <div className="cart-name  --summary">{title}</div>
            </div>

            <div className="cart-ingredients --summary">
              {contextReact.cart.map((person: any, i: number) => {
                return (
                  <div className="cart-lineItem  --summary">
                    <div className="cart-rowSmall --summary">
                      <EditIcon />
                      <p>{person.name}</p>
                    </div>
                    <div className="cart-rowBig --summary">
                      <p>
                        {"$"}
                        {contextReact.shopifyCart &&
                        contextReact.shopifyCart?.lineItems &&
                        typeof contextReact.shopifyCart?.lineItems[i] !==
                          undefined
                          ? (
                              Math.round(
                                parseFloat(
                                  contextReact.shopifyCart.lineItems?.[i]
                                    ?.originalUnitPrice +
                                    getExtraCost(i, contextReact)
                                ) *
                                  contextReact.shopifyCart.lineItems?.[i]
                                    ?.quantity *
                                  100
                              ) / 100
                            ).toFixed(2)
                          : ""}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="cart-footer --summary">
              <div className="cart-rowSmall  --summary">
                <div className="cartSummary-sub">Subtotal</div>

                <div className="cartSummary-tax">Tax</div>
                <div className="cartSummary-total">Total</div>
              </div>
              <div className="cart-rowBig --summary">
                <div className="cartSummary-sub">
                  $
                  {(
                    Math.round(contextReact.shopifyCart.subtotalPrice * 100) /
                    100
                  ).toFixed(2)}
                </div>
                <div className="cartSummary-tax">
                  $
                  {(
                    Math.round(contextReact.shopifyCart.totalTax * 100) / 100
                  ).toFixed(2)}
                </div>
                <div className="cartSummary-total">
                  ${" "}
                  {(
                    Math.round(contextReact.shopifyCart.totalPrice * 100) / 100
                  ).toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

function getExtraCost(index: any, contextReact: any): any {
  let extraPrice: any = 0;
  contextReact.cart[index].sweets.forEach((element: any) => {
    if (element.price && parseFloat(element.price) > 0) {
      extraPrice = extraPrice + parseFloat(element.price);
    }

    // console.log(extraPrice);
  });
  contextReact.cart[index].addIns.forEach((element: any) => {
    if (element.price && parseFloat(element.price) > 0) {
      extraPrice = extraPrice + parseFloat(element.price);
    }

    // console.log(extraPrice);
  });
  contextReact.cart[index].addOns.forEach((element: any) => {
    if (element.price && parseFloat(element.price) > 0) {
      extraPrice = extraPrice + parseFloat(element.price);
    }

    // console.log(extraPrice);
  });
  return extraPrice;
}
